import React, { useCallback, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Query } from '@material-table/core';
import MTable from '../../../../../Components/MTable/MTable';
import { ChangeFilter } from '../Filters';
import { useFilter } from '../../../../../Components/ListFilter';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
import { useAptorApi } from '../../../../../Api';
import { IGridQueryRequest, OrderDirection } from '../../../../../Api/AptorApi';
import { useIsMounted } from '../../../../../Hooks/useIsMounted';
import moment from 'moment';

type ComplianceControlDue = {
  lawId: number;
  lawName: string;
  effectiveFrom: Date;
  customerCompanyUnit: string;
  userId: number;
  userName: string;
  nextComplianceIntervalStart: Date;
  nextComplianceIntervalEnd: Date;
};

export const CompliancesDue = () => {
  const { getCompanyUnitName } = useContext(UserContext);
  const { formatMessage } = useIntl();
  const { api } = useAptorApi();
  const [filters, setFilter] = useFilter();
  const tableRef = React.useRef<any>(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted) {
      tableRef.current && (tableRef.current as any).onQueryChange();
    }
  }, [filters, tableRef, isMounted]);

  const handleDataFetch = useCallback(
    async (query: Query<ComplianceControlDue>) => {
      return await api.searchStatisticsCompliancesDue<ComplianceControlDue>({
        orderDirection: query.orderDirection === 'desc' ? OrderDirection.Descending : OrderDirection.Ascending,
        orderBy: query.orderBy !== undefined ? query.orderBy.field : 'lawName',
        page: query.page,
        pageSize: query.pageSize,
        search: query.search,
        filters: filters,
      } as IGridQueryRequest);
    },
    [api, filters],
  );

  const renderDate = (date?: Date) => {
    return date ? moment(date).format('ll') : undefined;
  };

  return (
    <>
      <ChangeFilter filters={filters} setFilter={setFilter} />
      <MTable
        tableRef={tableRef}
        columns={[
          {
            title: formatMessage({ id: 'law-portal.statistics.table.law' }),
            field: 'lawName',
            render: (row) => <Link to={`/law-portal/our-laws/${row.lawId}`}>{row.lawName}</Link>,
          },
          {
            title: formatMessage({ id: 'law-portal.statistics.table.effectiveFrom' }),
            field: 'effectiveFrom',
            render: (row) => renderDate(row.effectiveFrom),
          },
          {
            title: getCompanyUnitName(formatMessage),
            field: 'customerCompanyUnit',
          },
          {
            title: formatMessage({ id: 'law-portal.statistics.table.user' }),
            field: 'userName',
          },
          {
            title: formatMessage({ id: 'law-portal.statistics.table.compliance-interval' }),
            field: 'compliance-interval',
            render: (row) => (
              <span>
                {renderDate(row.nextComplianceIntervalStart)} - {renderDate(row.nextComplianceIntervalEnd)}
              </span>
            ),
            sorting: false,
          },
        ]}
        data={handleDataFetch}
        components={{}}
      />
    </>
  );
};
